module.exports = __webpack_public_path__ + "static/media/smallHiddenPerson.d91907ac.png";